module.exports = __webpack_public_path__ + "static/media/6h.cb718673.png";